<script setup lang="ts">
interface DateCardTagProps {
  date: string;
}
const props = defineProps<DateCardTagProps>();
</script>

<template>
  <div class="date-card-tag">
    {{ props.date }}
  </div>
</template>

<style scoped lang="scss">
.date-card-tag {
  background-color: var(--color-brand-summer);
  text-align: center;
  padding: var(--spacing-8);
  position: absolute;
  top: 0;
  left: 0;
  border-bottom-right-radius: var(--border-radius-8);
  @include font-label-s-light;
}
</style>
